import React from 'react';
import crazy from '../../Assests/Images/Screenshot_2023-04-12-01-09-19-04.jpg'

const Team = () => {
    return (
        <div>
            {/* <!-- component -->
<!--- more free and premium Tailwind CSS components at https://tailwinduikit.com/ ---> */}
            <div class="">
                <div class="w-full flex justify-center">
                    <div class="w-full md:w-12/12 xl:w-12/12  bg-gradient-to-r from-indigo-900 to-indigo-700 md:py-8  px-5 py-4 xl:py-16">
                        <div>
                            <div class="flex flex-wrap px-2 md:px-32 justify-between items-center md:flex-row flex-col-reverse">
                                <div
                                data-aos="fade-right" data-aos-duration="1000"
                                class="md:w-2/3 w-full pb-6 md:pb-0 md:pr-6 flex-col md:block flex items-center justify-center md:pt-0 pt-4">
                                    <div >
                                        <h1 class="text-xl md:text-2xl lg:text-3xl xl:text-4xl lg:w-10/12 text-white font-black leading-6 lg:leading-10 md:text-left text-center">Become a member and start building the next big thing</h1>
                                    </div>
                                    <p className='text-white py-3 text-lg text-left'>"Crazy Artist Studio" is a photography page that celebrates the wild and whimsical side of art and creativity. Through stunning visual storytelling and captivating imagery, this page showcases the extraordinary perspectives and unique visions of talented photographers who dare to think outside the box. From surreal landscapes and mind-bending abstracts, to bold portraits and vibrant street scenes, Crazy Artist is a colorful journey into the boundless depths of human imagination. Follow us and join the wild ride!</p>
                                    <button
                                        data-te-ripple-init
                                        data-te-ripple-color="blue"
                                        aria-label="Join the community" class="mt-5 lg:mt-8 py-3 lg:py-4 px-4 lg:px-8 bg-white font-bold text-indigo-700 rounded-lg text-sm lg:text-lg xl:text-xl hover:bg-opacity-90  focus:ring-2 focus:ring-offset-2 focus:ring-white focus:outline-none">
                                        <a href="https://www.facebook.com/CrazyArtistOfficial" target='_blank '>Join Crazy Artist</a>
                                    </button>
                                </div>
                                <div
                               
                                class="md:w-3/12 w-2/3">
                                    {/* <!-- component --> */}
                                    <div
                                     data-aos="zoom-in" data-aos-duration="1000"
                                    class=" mx-auto mb-5  flex-col rounded-3xl border-4 border-t-8 border-gray-900 bg-white  text-black shadow-2xl">
                                        <a href="https://www.facebook.com/CrazyArtistOfficial" target='_blank '>
                                            <img src={crazy} className='w-full rounded-2xl' alt="cartoon avatars" />
                                        </a>

                                        <div class="text-center  font-extrabold bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 rounded-b-2xl pb-2 pt-1 border-t-2 border-black text-white"  >Crazy Artist</div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Team;